module.exports = {"620822001":"街道","620822100":"中台镇","620822101":"邵寨镇","620822102":"独店镇","620822103":"什字镇","620822104":"朝那镇","620822105":"西屯镇","620822106":"上良镇","620822107":"百里镇","620822108":"蒲窝镇","620822201":"新开乡","620822204":"梁原乡","620822205":"龙门乡","620822206":"星火乡","620822400":"万宝川农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620822.json
// module id = 2714
// module chunks = 0